export const getApartmentStatus = (apartmentsStatus, apartmentId) =>
  apartmentsStatus.find(apartment => apartment.id === apartmentId).status
